import has from 'lodash.has';
import head from 'lodash.head';

const hasBase = (item: any): boolean => (item ? has(item, 'base') : false);

const hasInstitutionalDiscount = (prices: Array<{ base?: any }>): boolean => hasBase(head(prices));

export default hasInstitutionalDiscount;
